import Draggable from './draggable';

export default Draggable;



// WEBPACK FOOTER //
// ./src/components/elements/draggable/index.js